export interface Interview {
  id: string;
  title: string;
  guest: string;
  guestTitle: string;
  thumbnail: string;
  guestPhoto: string;
  country: string;
  countryFlag: string;
  sector: string;
  duration: string;
  views: number;
  date: string;
  excerpt: string;
  videoUrl: string;
  featured?: boolean;
  tags: string[];
}

export const interviews: Interview[] = [
  {
    id: "int-1",
    title: "\"L'Afrique n'a pas besoin d'aide, elle a besoin d'opportunités\" — Strive Masiyiwa",
    guest: "Strive Masiyiwa",
    guestTitle: "Fondateur d'Econet Wireless, Zimbabwe",
    thumbnail: "https://public.readdy.ai/ai/img_res/a6bd688e12c17b9a0e1d3092026558cf.jpg",
    guestPhoto: "https://readdy.ai/api/search-image?query=african%20businessman%20professional%20portrait%20confident%20suit%20Zimbabwe%20entrepreneur%20leader%20warm%20lighting%20studio&width=200&height=200&seq=gphoto1&orientation=squarish",
    country: "Zimbabwe",
    countryFlag: "🇿🇼",
    sector: "Télécoms",
    duration: "42 min",
    views: 128400,
    date: "2026-04-05",
    excerpt: "Strive Masiyiwa revient sur ses 5 ans de bataille juridique pour obtenir une licence télécom, sa vision de l'Afrique en 2030 et ses conseils aux jeunes entrepreneurs.",
    videoUrl: "https://www.youtube.com/embed/h82_D5R5wxs",
    featured: true,
    tags: ["Leadership", "Résilience", "Télécoms", "Vision Afrique"],
  },
  {
    id: "int-2",
    title: "Comment Fatoumata Bâ a levé 100M$ pour les femmes entrepreneures africaines",
    guest: "Fatoumata Bâ",
    guestTitle: "Fondatrice de Janngo Capital, Mali",
    thumbnail: "https://readdy.ai/api/search-image?query=african%20woman%20entrepreneur%20interview%20studio%20professional%20confident%20speaking%20investor%20Mali%20France%20dark%20background%20spotlight%20modern&width=800&height=450&seq=int2&orientation=landscape",
    guestPhoto: "https://readdy.ai/api/search-image?query=african%20malian%20woman%20investor%20professional%20portrait%20confident%20modern%20warm%20lighting%20studio&width=200&height=200&seq=gphoto2&orientation=squarish",
    country: "Mali",
    countryFlag: "🇲🇱",
    sector: "Finance",
    duration: "38 min",
    views: 94200,
    date: "2026-03-28",
    excerpt: "Fatoumata Bâ partage sa stratégie d'investissement, les critères qu'elle recherche chez les fondatrices africaines et pourquoi le genre est un avantage compétitif.",
    videoUrl: "https://www.youtube.com/embed/EiDxR1F9__k",
    featured: true,
    tags: ["Investissement", "Femmes", "Capital-risque", "Impact"],
  },
  {
    id: "int-3",
    title: "Iddris Sandu : \"Je code pour l'Afrique depuis la Silicon Valley\"",
    guest: "Iddris Sandu",
    guestTitle: "Développeur & Entrepreneur, Ghana → USA",
    thumbnail: "https://readdy.ai/api/search-image?query=young%20african%20tech%20developer%20interview%20studio%20creative%20modern%20confident%20speaking%20Ghana%20Silicon%20Valley%20dark%20background%20spotlight&width=800&height=450&seq=int3&orientation=landscape",
    guestPhoto: "https://readdy.ai/api/search-image?query=young%20african%20ghanaian%20developer%20professional%20portrait%20confident%20creative%20modern%20warm%20lighting%20studio&width=200&height=200&seq=gphoto3&orientation=squarish",
    country: "Ghana → USA",
    countryFlag: "🇬🇭🇺🇸",
    sector: "Tech",
    duration: "29 min",
    views: 187600,
    date: "2026-03-20",
    excerpt: "Le prodige ghanéen de la Silicon Valley parle de son parcours, de sa collaboration avec Kanye West et de sa mission : créer des technologies pour les communautés africaines.",
    videoUrl: "https://www.youtube.com/embed/HhqE8i5e0aw",
    featured: false,
    tags: ["Tech", "Diaspora", "Innovation", "Jeunesse"],
  },
  {
    id: "int-4",
    title: "Yvonne Otieno : L'IA au service des agriculteurs kényans",
    guest: "Yvonne Otieno",
    guestTitle: "Fondatrice de FarmDrive, Kenya",
    thumbnail: "https://readdy.ai/api/search-image?query=african%20kenyan%20woman%20entrepreneur%20interview%20studio%20professional%20confident%20speaking%20agritech%20AI%20dark%20background%20spotlight%20modern&width=800&height=450&seq=int4&orientation=landscape",
    guestPhoto: "https://readdy.ai/api/search-image?query=african%20kenyan%20woman%20entrepreneur%20professional%20portrait%20confident%20modern%20warm%20lighting%20studio&width=200&height=200&seq=gphoto4&orientation=squarish",
    country: "Kenya",
    countryFlag: "🇰🇪",
    sector: "AgriTech",
    duration: "33 min",
    views: 62800,
    date: "2026-03-12",
    excerpt: "Yvonne explique comment FarmDrive utilise l'IA pour scorer le crédit des agriculteurs sans historique bancaire et son ambition de toucher 1 million d'agriculteurs d'ici 2027.",
    videoUrl: "https://www.youtube.com/embed/ynZwIPSGhOQ",
    featured: false,
    tags: ["AgriTech", "IA", "Financement", "Kenya"],
  },
  {
    id: "int-5",
    title: "Karim Sy : \"Dakar est le prochain hub tech mondial\"",
    guest: "Karim Sy",
    guestTitle: "Fondateur de Jokkolabs, Sénégal",
    thumbnail: "https://readdy.ai/api/search-image?query=african%20senegalese%20entrepreneur%20interview%20studio%20professional%20confident%20speaking%20tech%20hub%20Dakar%20dark%20background%20spotlight%20modern&width=800&height=450&seq=int5&orientation=landscape",
    guestPhoto: "https://readdy.ai/api/search-image?query=african%20senegalese%20man%20entrepreneur%20professional%20portrait%20confident%20modern%20warm%20lighting%20studio&width=200&height=200&seq=gphoto5&orientation=squarish",
    country: "Sénégal",
    countryFlag: "🇸🇳",
    sector: "Tech",
    duration: "45 min",
    views: 78300,
    date: "2026-03-05",
    excerpt: "Karim Sy partage sa vision de l'écosystème startup africain, les erreurs à éviter pour les jeunes entrepreneurs et pourquoi Dakar est en train de devenir un hub tech mondial.",
    videoUrl: "https://www.youtube.com/embed/PS9KYvYvlvY",
    featured: false,
    tags: ["Écosystème", "Startup", "Sénégal", "Coworking"],
  },
];
